// extracted by mini-css-extract-plugin
module.exports = {"title":"src-components-FormResponse-IncompatibleWarning-styles___title","list":"src-components-FormResponse-IncompatibleWarning-styles___list"};